(function() {
    "use strict";
    angular.module("app").component("newsItem", {
        templateUrl: "@/news/news-item.html",
        bindings: {
            newsItem: "=",
            index: "<",
            collapsible: "=",
        },
        controller: NewsItemController
    });

    NewsItemController.$inject = [];
    function NewsItemController() {
    }
})();